import { render, staticRenderFns } from "./CarGameManagement.vue?vue&type=template&id=5a1ed48c&scoped=true&"
import script from "./CarGameManagement.vue?vue&type=script&lang=js&"
export * from "./CarGameManagement.vue?vue&type=script&lang=js&"
import style0 from "./CarGameManagement.vue?vue&type=style&index=0&id=5a1ed48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ed48c",
  null
  
)

export default component.exports